import { createSlice } from "@reduxjs/toolkit";

import { getIngestionData } from "./actions";

const initialState = { ingestionData: [] };

export const ingestionSlice = createSlice({
  name: "ingestion",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getIngestionData.fulfilled, (state, action) => {
      if (action?.payload?.success) {
        state.ingestionData = action?.payload?.data;
      }
    });
  },
});

export default ingestionSlice.reducer;
